import {ScanSampleStageDTO} from "./scanSampleDTO.interface";
import {ScanErrorDTO} from "./scanErrorDTO.interface";

export interface ScanSampleResponseDTO {
  scanSampleUrl: string;
  scanSample: ScanSampleStageDTO;
  scanErrors: ScanErrorDTO[];
}
